import {createAction} from 'Shared/utilities/actionCreator';
import * as C from '../models/ContingentBeneficiary';
import {ContingentBeneficiary} from '../models/ContingentBeneficiary';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {PhoneNumber} from 'ApplicationEntry/models/PhoneNumber';
import {StringUnion} from 'Core/models/EmptyString';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export enum ContingentBeneficiaryActionType {
  CHANGE_FIRST_NAME = 'contingentBeneficiary/CHANGE_FIRST_NAME',
  CHANGE_MIDDLE_NAME = 'contingentBeneficiary/CHANGE_MIDDLE_NAME',
  CHANGE_LAST_NAME = 'contingentBeneficiary/CHANGE_LAST_NAME',
  CHANGE_RELATIONSHIP = 'contingentBeneficiary/CHANGE_RELATIONSHIP',
  CHANGE_PERCENT = 'contingentBeneficiary/CHANGE_PERCENT',
  CHANGE_SOCIAL_SECURITY_NUMBER = 'contingentBeneficiary/CHANGE_SOCIAL_SECURITY_NUMBER',
  CHANGE_DATE_OF_BIRTH = 'contingentBeneficiary/CHANGE_DATE_OF_BIRTH',
  CHANGE_PHONE = 'contingentBeneficiary/CHANGE_PHONE',
  CHANGE_ADDRESS = 'contingentBeneficiary/CHANGE_ADDRESS',
  CHANGE_ADDRESS_LINE2 = 'contingentBeneficiary/CHANGE_ADDRESS_LINE2',
  CHANGE_CITY = 'contingentBeneficiary/CHANGE_CITY',
  CHANGE_STATE = 'contingentBeneficiary/CHANGE_STATE',
  CHANGE_ZIP = 'contingentBeneficiary/CHANGE_ZIP',
  UPDATE_CONTINGENT_BENEFICIARY = 'contingentBeneficiary/UPDATE_CONTINGENT_BENEFICIARY',
}

export const updateContingentBeneficiaryValues = (
  firstName: StringUnion,
  middleName: StringUnion,
  lastName: StringUnion,
  relationship: StringUnion,
  percent: number,
  socialSecurityNumber: string,
  dateOfBirth: Date | '',
  phone: PhoneNumber,
  address: StringUnion,
  addressLine2: StringUnion,
  city: StringUnion,
  state: StringUnion,
  zip: ZipCode,
  occSmokerCode: StringUnion,
  signatureDate: Date | '',
) =>
  createAction(ContingentBeneficiaryActionType.UPDATE_CONTINGENT_BENEFICIARY, {
    firstName,
    middleName,
    lastName,
    relationship,
    percent,
    socialSecurityNumber,
    dateOfBirth,
    phone,
    address,
    addressLine2,
    city,
    state,
    zip,
    occSmokerCode,
    signatureDate
  });

export type ContingentBeneficiaryAction = | ReturnType<typeof updateContingentBeneficiaryValues>;

export const isContingentBeneficiaryAction = (action: any): action is ContingentBeneficiaryAction =>
  action.type in reverseEnum(ContingentBeneficiaryActionType);

type ContingentBeneficiaryState = ContingentBeneficiary;
const DEFAULT_STATE: ContingentBeneficiaryState = C.EmptyContingentBeneficiary;

export default (state: ContingentBeneficiaryState = DEFAULT_STATE, action: ContingentBeneficiaryAction) => {
  switch (action.type) {
    case ContingentBeneficiaryActionType.UPDATE_CONTINGENT_BENEFICIARY:
      return C.updateContingentBeneficiaryValues(
        action.payload.firstName,
        action.payload.middleName,
        action.payload.lastName,
        action.payload.relationship,
        action.payload.percent,
        action.payload.socialSecurityNumber,
        action.payload.dateOfBirth,
        action.payload.phone,
        action.payload.address,
        action.payload.addressLine2,
        action.payload.city,
        action.payload.state,
        action.payload.zip,
        action.payload.occSmokerCode,
        action.payload.signatureDate,
      )();
    default:
      return state;
  }
};
